import React, { useState, useContext } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { ReCaptchaProvider } from "@wojtekmaj/react-recaptcha-v3";

import {
  TabsContainer,
  Container,
  AccordionContainer,
} from "./SessionRequest.style";

import { Tabs, Tab } from "../../../ui/Tabs/Tabs";
import { Accordion } from "../../DashboardView/Accordion/Accordion";
import { NewRequest } from "../../../components/EducationSessionRequest/NewRequest";
import { RequestHistory } from "../../../components/EducationSessionRequest/RequestHistory";
import { UserContext } from "../../../context/UserContext";
import { Breadcrumbs } from "../../../components/Breadcrumbs/Breadcrumbs";
import { PageTitle } from "../../../components/PageTitle/PageTitle";
import { Button } from "../../../ui/Button/Button";
import { Link } from "../../../components/Link/Link";

export const SessionRequest = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const [initialExpanded, setInitialExpanded] = useState(0);
  const { user } = useContext(UserContext);

  return (
    <ReCaptchaProvider reCaptchaKey="6LeA7NArAAAAACCeXSm2qZ7XYrT7mArWT-Xk3huG">
      <Breadcrumbs
        breadcrumbs={[
          {
            to: "/",
            label: intl.formatMessage({
              defaultMessage: "Home",
            }),
          },
          {
            to: "/education",
            label: intl.formatMessage({
              defaultMessage: "Education",
            }),
          },
          {
            to: null,
            label: intl.formatMessage({
              defaultMessage: "Request",
            }),
          },
        ]}
      />
      <PageTitle
        title={intl.formatMessage({
          defaultMessage: "In-Salon Artist Class Form",
        })}
        append={
          user && (
            <Button as={Link} to="/dashboard" variant="action" type="button">
              <FormattedMessage defaultMessage="manage dashboard" />
            </Button>
          )
        }
      />

      {user ? (
        <TabsContainer>
          <Tabs>
            <Tab
              className={
                location.pathname.endsWith("/education/request") && "--active"
              }
              type="button"
              onClick={() =>
                navigate(`/${intl.locale}/education/request`, {
                  preventScrollReset: true,
                })
              }
            >
              <FormattedMessage defaultMessage="New Request" />
            </Tab>
            <Tab
              className={
                location.pathname.endsWith("/education/request/history") &&
                "--active"
              }
              type="button"
              onClick={() =>
                navigate(`/${intl.locale}/education/request/history`, {
                  preventScrollReset: true,
                })
              }
            >
              <FormattedMessage defaultMessage="Request History" />
            </Tab>
          </Tabs>

          <AnimatePresence mode="sync">
            <Container
              key={location.pathname}
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.4 }}
            >
              <Outlet />
            </Container>
          </AnimatePresence>
        </TabsContainer>
      ) : (
        <Outlet />
      )}

      {user && (
        <AccordionContainer>
          <Accordion
            expanded={initialExpanded}
            setExpanded={(e) => setInitialExpanded(e)}
            items={[
              {
                title: intl.formatMessage({
                  defaultMessage: "New Request",
                }),
                content: <NewRequest />,
              },
              {
                title: intl.formatMessage({
                  defaultMessage: "Request History",
                }),
                content: <RequestHistory />,
              },
            ]}
          />
        </AccordionContainer>
      )}
    </ReCaptchaProvider>
  );
};
